import React, { useContext, useEffect, useState } from "react";
import DataContext from "../../Context/DAtaContext";
import UsersContext from "../../Context/UsersContext";
import { motion } from "framer-motion";
// icons imports
import { IoArrowBack } from "react-icons/io5";
import FarmerTable from "./../../Farmer/FarmerTable";
import SummaryTable from "./../../Farmer/SummaryTable";
import FarmerFinish from "../../Farmer/FarmerFinish";
import ProfessionalWidget from "./Widgets";

function AdminHome() {
  const { Zones, Payment } = useContext(DataContext);
  const { Villages } = useContext(DataContext);
  const { users, farmers, user } = useContext(UsersContext);
  const [Vanos, setVans] = useState([]);
  const [Fam, setFam] = useState([]);
  const [Pay, setPay] = useState([]);
  const [ZoneData, setZoneData] = useState("");
  const [VanoStats, setVanoStats] = useState("");
  const [RegFarmers, setRegFarmers] = useState("");
  const [userdetails, setuserdetails] = useState("");
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);

  // find user profile data
  const userProfile = users?.find((dt) => dt?.id === user?.id);

  // Total money calculation logic for each Zone
  const ZonesTotalSales = Zones?.map((dt, index) => {
    const villageByZone = Zones?.map((dt) =>
      Villages?.filter((village) => village.zone_id === dt.id),
    );
    //   Makambako Zone Total sales Calculations
    const MakambakoFamers = villageByZone[index]?.map((dt) =>
      farmers?.filter((fama) => fama.village_id === dt.id),
    );
    const MK = MakambakoFamers.flat();
    const payment = MK?.map((mk) =>
      Payment?.filter((pay) => pay?.farmer_id === mk?.uuid),
    );
    const MakambakoTotalSales = payment.flat();
    const totalSumPay = MakambakoTotalSales?.reduce(
      (sum, payment) => sum + payment.amount,
      0,
    );
    return totalSumPay;
  });
  // Total farmers calculation logic for each Zone
  const ZonesTotalFarmers = Zones?.map((dt, index) => {
    const villageByZone = Zones?.map((dt) =>
      Villages?.filter((village) => village.zone_id === dt.id),
    );
    //   Makambako Zone Total sales Calculations
    const MakambakoFamers = villageByZone[index]?.map((dt) =>
      farmers?.filter((fama) => fama.village_id === dt.id),
    );
    const MK = MakambakoFamers.flat();
    return MK;
  });

  // second selections logic
  const handleSelections = (index) => {
    setShow1(false);
    setShow3(true);
    const villageByZone = Zones?.map((dt) =>
      Villages?.filter((village) => village.zone_id === dt.id),
    );
    // Assigning zone name from selection
    setZoneData(Zones[index]);

    // collecting farmers belonging to specific zone
    const MakambakoFamers = villageByZone[index]?.map((dt) =>
      farmers?.filter((fama) => fama.village_id === dt.id),
    );
    const MK = MakambakoFamers.flat();
    setFam(MK);

    // payments logic
    const payment = MK?.map((mk) =>
      Payment?.filter((pay) => pay?.farmer_id === mk?.uuid),
    );

    // handle vano
    const ZoneVanoStats = users
      ?.map((user) => MK?.filter((farmer) => farmer?.creator_id === user?.id))
      .filter((result) => result.length > 0);
    setVanoStats(ZoneVanoStats);

    const ZoneVano = users?.filter((user) => {
      const userFarmers = MK?.filter(
        (farmer) => farmer?.creator_id === user?.id,
      );
      return userFarmers.length > 0; // Keep only users with non-empty arrays
    });
    setVans(ZoneVano);

    const MakambakoTotalSales = payment.flat();
    const totalSumPay = MakambakoTotalSales?.reduce(
      (sum, payment) => sum + payment.amount,
      0,
    );
    setPay(totalSumPay);
  };

  //   First selection logic
  const handleSelection = (index) => {
    setShow1(false);
    setShow2(true);

    //   Makambako Zone Total sales Calculations
    const villageByZone = Zones?.map((dt) =>
      Villages?.filter((village) => village.zone_id === dt.id),
    );
    // Assigning zone name from selection
    setZoneData(Zones[index]);

    // village selection per zone
    const MakambakoFamers = villageByZone[index]?.map((dt) =>
      farmers?.filter((fama) => fama.village_id === dt.id),
    );
    const MK = MakambakoFamers.flat();
    setFam(MK);
    const payment = MK?.map((mk) =>
      Payment?.filter((pay) => pay?.farmer_id === mk?.uuid),
    );

    // handle vano
    const ZoneVanoStats = users
      ?.map((user) => MK?.filter((farmer) => farmer?.creator_id === user?.id))
      .filter((result) => result.length > 0);
    setVanoStats(ZoneVanoStats);

    const ZoneVano = users?.filter((user) => {
      const userFarmers = MK?.filter(
        (farmer) => farmer?.creator_id === user?.id,
      );
      return userFarmers.length > 0; // Keep only users with non-empty arrays
    });
    setVans(ZoneVano);

    const MakambakoTotalSales = payment.flat();
    const totalSumPay = MakambakoTotalSales?.reduce(
      (sum, payment) => sum + payment.amount,
      0,
    );
    setPay(totalSumPay);
  };

  //   handle Back Logic
  const handleBack = () => {
    setShow1(true);
    setShow2(false);
  };

  const handleBacks = () => {
    setShow1(true);
    setShow3(false);
  };

  const handleReturn = () => {
    setShow3(true);
    setShow4(false);
  };
  const handleReturns = () => {
    setShow2(true);
    setShow5(false);
  };

  // handles Farmer selection
  const handleFarmerSelection = (id) => {
    const userdetails = users?.filter((dt) => dt?.id === id);
    const RegFarmers = farmers?.filter((dt) => dt?.creator_id === id);
    setRegFarmers(RegFarmers);
    setuserdetails(userdetails);
    if (userProfile?.role === "supervisor") {
      setShow3(false);
      setShow4(true);
    }
  };

  const handleFarmerSelections = (id) => {
    const userdetails = users?.filter((dt) => dt?.id === id);
    const RegFarmers = farmers?.filter((dt) => dt?.creator_id === id);
    setRegFarmers(RegFarmers);
    setuserdetails(userdetails);
    if (userProfile?.role === "supervisor") {
      setShow2(false);
      setShow5(true);
    }
  };

  // total amount accumulated
  const totalZone = ZonesTotalSales.reduce((sum, payment) => sum + payment, 0);
  const totalFarmers = ZonesTotalFarmers.flat();

  const [totalTarget, setTotalTarget] = useState(0);
  const [totalAchieved, setTotalAchieved] = useState(0);
  const [totalTargetSales, setTotalTargetSales] = useState(0);

  useEffect(() => {
    // Initialize totals
    let accumulatedTarget = 0;
    let accumulatedAchieved = 0;
    let totalPay = 0; // Initialize totalPay

    Zones?.forEach((zone, index) => {
      // Get all villages for the current zone
      const villageByZone = Villages?.filter(
        (village) => village.zone_id === zone.id,
      );

      // Get all farmers from the villages in the current zone
      const MakambakoFarmers = villageByZone
        ?.map((village) =>
          farmers?.filter((farmer) => farmer.village_id === village.id),
        )
        .flat();

      // Get users who have farmers in the current zone
      const ZoneVano = users?.filter((user) =>
        MakambakoFarmers?.some((farmer) => farmer.creator_id === user.id),
      );

      // Calculate the target for the current zone
      const currentTarget = zone?.target * (ZoneVano?.length || 1); // Use 0 if ZoneVano is undefined
      accumulatedTarget += currentTarget;

      // Calculate total payments for the current zone
      const totalPayment = zone?.sales * (ZoneVano?.length || 1); // Use 0 if ZoneVano is undefined
      totalPay += totalPayment;

      // Calculate achieved for the current zone
      const currentAchieved = ZonesTotalFarmers[index]?.length || 0; // Use 0 if undefined
      accumulatedAchieved += currentAchieved;
    });

    // Update state with accumulated totals
    setTotalTargetSales(totalPay);
    setTotalTarget(accumulatedTarget);
    setTotalAchieved(accumulatedAchieved);
  }, [Zones, Villages, farmers, users, ZonesTotalFarmers]);

  return (
    <div>
      {show1 ? (
        <>
          {/* first section - widget section */}
          <div className="md:mb-10">
            <ProfessionalWidget
              farmersTarget={totalTarget}
              AchievedFarmers={totalAchieved}
              SalesTarget={totalTargetSales}
              ArchievedSales={totalZone}
            />
          </div>
          {/* Enrollment Table */}
          <div className="flex flex-row items-center mb-5 gap-x-3">
            <div>
              <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
                Payments Summary
              </h1>
            </div>
          </div>
          {/* Enables horizontal scrolling on small screens */}
          <div className="overflow-x-auto ">
            <motion.table
              className="w-full"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <thead className="">
                <tr className="bg-green-600 border-b md:text-sm dark:border-gray-700">
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    Zone
                  </th>
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    ZNC
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Target
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Achieved
                  </th>
                  <th className="hidden p-2 text-xs font-bold text-center text-white md:table-cell lg:text-base md:text-sm">
                    Remain
                  </th>
                  <th className="hidden p-2 text-xs font-bold text-center text-white md:table-cell lg:text-base md:text-sm">
                    %
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {Zones?.map((item, index) => (
                  <motion.tr
                    key={index}
                    onClick={() => handleSelections(index)}
                    className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700 "
                  >
                    <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                      {item.name}
                    </td>
                    <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                      {item?.cordnator}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {(() => {
                        const villageByZone = Zones?.map((dt) =>
                          Villages?.filter(
                            (village) => village.zone_id === dt.id,
                          ),
                        );

                        const MakambakoFamers = villageByZone[index]?.map(
                          (dt) =>
                            farmers?.filter(
                              (fama) => fama.village_id === dt.id,
                            ),
                        );
                        const MK = MakambakoFamers.flat();

                        const ZoneVano = users?.filter((user) => {
                          const userFarmers = MK?.filter(
                            (farmer) => farmer?.creator_id === user?.id,
                          );
                          return userFarmers.length > 0; // Keep only users with non-empty arrays
                        });

                        return (
                          <span>
                            {(
                              item?.sales * ZoneVano?.length || item?.sales
                            )?.toLocaleString()}
                          </span>
                        );
                      })()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {ZonesTotalSales[index].toLocaleString()}
                    </td>
                    <td className="hidden p-2 text-xs text-center text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                      {(() => {
                        const villageByZone = Zones?.map((dt) =>
                          Villages?.filter(
                            (village) => village.zone_id === dt.id,
                          ),
                        );

                        const MakambakoFamers = villageByZone[index]?.map(
                          (dt) =>
                            farmers?.filter(
                              (fama) => fama.village_id === dt.id,
                            ),
                        );
                        const MK = MakambakoFamers.flat();

                        const ZoneVano = users?.filter((user) => {
                          const userFarmers = MK?.filter(
                            (farmer) => farmer?.creator_id === user?.id,
                          );
                          return userFarmers.length > 0; // Keep only users with non-empty arrays
                        });

                        const targetSales =
                          item?.sales * ZoneVano?.length -
                          ZonesTotalSales[index];

                        return (
                          <span>
                            {(targetSales !== 0
                              ? targetSales
                              : item?.sales
                            )?.toLocaleString()}
                          </span>
                        );
                      })()}
                    </td>
                    <td className="hidden p-2 text-xs text-center md:table-cell md:text-sm">
                      {(() => {
                        const villageByZone = Zones?.map((dt) =>
                          Villages?.filter(
                            (village) => village.zone_id === dt.id,
                          ),
                        );

                        const MakambakoFamers = villageByZone[index]?.map(
                          (dt) =>
                            farmers?.filter(
                              (fama) => fama.village_id === dt.id,
                            ),
                        );

                        const MK = MakambakoFamers?.flat() || [];

                        const ZoneVano = users?.filter((user) => {
                          const userFarmers = MK?.filter(
                            (farmer) => farmer?.creator_id === user?.id,
                          );

                          return userFarmers.length > 0;
                        });

                        // Calculate percentage
                        const rawPercentage =
                          (ZonesTotalSales[index] /
                            (item?.sales * ZoneVano?.length)) *
                          100;

                        // Prevent NaN/Infinity and cap percentage at 100
                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return (
                          <span
                            className={
                              percentage < 33
                                ? "text-red-600"
                                : percentage < 66
                                  ? "text-yellow-600"
                                  : "text-green-600"
                            }
                          >
                            {percentage.toFixed(2)} %
                          </span>
                        );
                      })()}
                    </td>
                  </motion.tr>
                ))}
                <motion.tr className="bg-gray-50 dark:bg-slate-900 ">
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm"></td>
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                    Total
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {totalTargetSales?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {totalZone?.toLocaleString()}
                  </td>
                  <td className="hidden p-2 text-xs text-center text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                    {(totalTargetSales - totalZone)?.toLocaleString()}
                  </td>
                  <td className="hidden p-2 text-xs text-center md:table-cell md:text-sm">
                    <span
                      className={(() => {
                        const rawPercentage =
                          (totalZone / totalTargetSales) * 100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return percentage < 33
                          ? "text-red-600"
                          : percentage < 66
                            ? "text-yellow-600"
                            : "text-green-600";
                      })()}
                    >
                      {(() => {
                        const rawPercentage =
                          (totalZone / totalTargetSales) * 100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return `${percentage.toFixed(1)} %`;
                      })()}
                    </span>
                  </td>
                </motion.tr>
              </tbody>
            </motion.table>
          </div>
          {/* Enrollment Summary */}
          <div className="flex flex-row items-center mt-10 mb-5 gap-x-3">
            {/* <FaPeopleGroup className="text-xl md:text-xl" /> */}
            <div>
              <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
                Enrollment Summary
              </h1>
            </div>
          </div>
          {/* Enrollment summary table */}
          <div className="overflow-x-auto ">
            {/* Enables horizontal scrolling on small screens */}
            <motion.table
              className="w-full"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <thead className="">
                <tr className="bg-green-600 border-b md:text-sm dark:border-gray-700">
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    Zone
                  </th>
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    ZNC
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Target
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Achieved
                  </th>
                  <th className="hidden p-2 text-xs font-bold text-center text-white md:table-cell lg:text-base md:text-sm">
                    Remain
                  </th>
                  <th className="hidden p-2 text-xs font-bold text-center text-white md:table-cell lg:text-base md:text-sm">
                    %
                  </th>
                </tr>
              </thead>
              <tbody>
                {Zones?.map((item, index) => (
                  <motion.tr
                    key={index}
                    onClick={() => handleSelection(index)}
                    className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700"
                  >
                    <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                      {item.name}
                    </td>
                    <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                      {item?.cordnator}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {(() => {
                        const villageByZone = Zones?.map((dt) =>
                          Villages?.filter(
                            (village) => village.zone_id === dt.id,
                          ),
                        );

                        const MakambakoFarmers = villageByZone[index]?.map(
                          (dt) =>
                            farmers?.filter(
                              (fama) => fama.village_id === dt.id,
                            ),
                        );
                        const MK = MakambakoFarmers.flat();

                        const ZoneVano = users?.filter((user) => {
                          const userFarmers = MK?.filter(
                            (farmer) => farmer?.creator_id === user?.id,
                          );
                          return userFarmers.length > 0; // Keep only users with non-empty arrays
                        });

                        const currentTarget =
                          item?.target * (ZoneVano?.length || 1);
                        return <span>{currentTarget?.toLocaleString()}</span>;
                      })()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {ZonesTotalFarmers[index]?.length}
                    </td>
                    <td className="hidden p-2 text-xs text-center text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                      {(() => {
                        const villageByZone = Zones?.map((dt) =>
                          Villages?.filter(
                            (village) => village.zone_id === dt.id,
                          ),
                        );

                        const MakambakoFarmers = villageByZone[index]?.map(
                          (dt) =>
                            farmers?.filter(
                              (fama) => fama.village_id === dt.id,
                            ),
                        );

                        const MK = MakambakoFarmers?.flat() || [];

                        const ZoneVano = users?.filter((user) => {
                          const userFarmers = MK?.filter(
                            (farmer) => farmer?.creator_id === user?.id,
                          );

                          return userFarmers.length > 0;
                        });

                        // Calculate remaining target
                        const calculatedTarget =
                          (item?.target ?? 0) * (ZoneVano?.length ?? 0) -
                          (ZonesTotalFarmers[index]?.length ?? 0);

                        // Never allow the remaining target to go below 0
                        const targetValue = Math.max(0, calculatedTarget);

                        return <span>{targetValue.toLocaleString()}</span>;
                      })()}
                    </td>
                    <td className="hidden p-2 text-xs text-center md:table-cell md:text-sm">
                      {(() => {
                        const villageByZone = Zones?.map((dt) =>
                          Villages?.filter(
                            (village) => village.zone_id === dt.id,
                          ),
                        );

                        const MakambakoFarmers = villageByZone[index]?.map(
                          (dt) =>
                            farmers?.filter(
                              (fama) => fama.village_id === dt.id,
                            ),
                        );

                        const MK = MakambakoFarmers?.flat() || [];

                        const ZoneVano = users?.filter((user) => {
                          const userFarmers = MK?.filter(
                            (farmer) => farmer?.creator_id === user?.id,
                          );

                          return userFarmers.length > 0;
                        });

                        // Calculate raw percentage
                        const rawPercentage =
                          (ZonesTotalFarmers[index]?.length /
                            ((item?.target ?? 0) * (ZoneVano?.length ?? 0))) *
                          100;

                        // Keep percentage between 0% and 100%
                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return (
                          <span
                            className={
                              percentage < 33
                                ? "text-red-600"
                                : percentage < 66
                                  ? "text-yellow-600"
                                  : "text-green-600"
                            }
                          >
                            {percentage.toFixed(2)} %
                          </span>
                        );
                      })()}
                    </td>
                  </motion.tr>
                ))}
                <motion.tr className="bg-gray-50 dark:bg-slate-900">
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm"></td>
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                    Total
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    <span>{totalTarget?.toLocaleString()}</span>
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {totalAchieved?.toLocaleString()}
                  </td>
                  <td className="hidden p-2 text-xs text-center text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                    {(totalTarget - totalAchieved)?.toLocaleString()}
                  </td>
                  <td className="hidden p-2 text-xs text-center text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                    <span
                      className={(() => {
                        const rawPercentage =
                          (totalAchieved / totalTarget) * 100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return percentage < 33
                          ? "text-red-600"
                          : percentage < 66
                            ? "text-yellow-600"
                            : "text-green-600";
                      })()}
                    >
                      {(() => {
                        const rawPercentage =
                          (totalAchieved / totalTarget) * 100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return `${percentage.toFixed(1)} %`;
                      })()}
                    </span>
                  </td>
                </motion.tr>
              </tbody>
            </motion.table>
          </div>
        </>
      ) : show2 ? (
        <>
          {/* second section - widget section */}
          <div className="mb-10">
            <ProfessionalWidget
              farmersTarget={ZoneData?.target * (Vanos?.length || 1)}
              AchievedFarmers={Fam?.length}
              SalesTarget={ZoneData?.sales * (Vanos?.length || 1)}
              ArchievedSales={Pay}
            />
          </div>
          <div
            onClick={handleBack}
            className="mb-5 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1 dark:text-gray-300"
          >
            <IoArrowBack className="text-2xl" />
            <h1 className="text-xs md:text-sm">Back</h1>
          </div>
          {/* Enrollment Table */}
          <div className="flex flex-row items-center mb-5 gap-x-3">
            <div>
              <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
                {ZoneData?.name} Zone Summary
              </h1>
            </div>
          </div>
          {/* Enables horizontal scrolling on small screens */}
          <div className="overflow-x-auto ">
            <motion.table
              className="w-full"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <thead className="">
                <tr className="bg-green-600 border-b md:text-sm dark:border-gray-700">
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    Particulars
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Target
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Achieved
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Remain
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    %
                  </th>
                </tr>
              </thead>
              <tbody className="">
                <motion.tr className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700 ">
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                    Enrollment
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(
                      ZoneData?.target * (Vanos?.length || 1)
                    )?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {Fam?.length}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(() => {
                      // Calculating the remaining amount
                      const targetValue =
                        ZoneData?.target * Vanos?.length - Fam?.length;

                      return (
                        targetValue !== 0 ? targetValue : ZoneData?.target
                      )?.toLocaleString();
                    })()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    <span
                      className={(() => {
                        const rawPercentage =
                          (Fam?.length /
                            ((ZoneData?.target ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return percentage < 33
                          ? "text-red-600"
                          : percentage < 66
                            ? "text-yellow-600"
                            : "text-green-600";
                      })()}
                    >
                      {(() => {
                        const rawPercentage =
                          (Fam?.length /
                            ((ZoneData?.target ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return `${percentage.toFixed(1)} %`;
                      })()}
                    </span>
                  </td>
                </motion.tr>
                <motion.tr className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700 ">
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                    sales
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(ZoneData?.sales * (Vanos?.length || 1))?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {Pay?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(() => {
                      // Calculating the remaining amount
                      const targetValue = ZoneData?.sales * Vanos?.length - Pay;

                      return (
                        targetValue !== 0 ? targetValue : ZoneData?.sales
                      )?.toLocaleString();
                    })()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    <span
                      className={(() => {
                        const rawPercentage =
                          (Pay /
                            ((ZoneData?.sales ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return percentage < 33
                          ? "text-red-600"
                          : percentage < 66
                            ? "text-yellow-600"
                            : "text-green-600";
                      })()}
                    >
                      {(() => {
                        const rawPercentage =
                          (Pay /
                            ((ZoneData?.sales ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return `${percentage.toFixed(1)} %`;
                      })()}
                    </span>
                  </td>
                </motion.tr>
              </tbody>
            </motion.table>
          </div>
          {/* Vano List in certain Zone */}
          <div className="flex flex-row items-center mt-10 mb-5 gap-x-3">
            <div>
              <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
                VANO list Summary
              </h1>
            </div>
          </div>
          {/* VANO List Table */}
          <div className="overflow-x-auto ">
            {/* Enables horizontal scrolling on small screens */}
            <motion.table
              className="w-full"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <thead className="">
                <tr className="bg-green-600 border-b md:text-sm dark:border-gray-700">
                  <th className="hidden p-2 text-xs font-bold text-left text-white md:table-cell lg:text-base md:text-sm">
                    No
                  </th>
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    VANO name
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Target
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Achieved
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Remain
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    %
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {Vanos?.map((item, index) => (
                  <motion.tr
                    key={index + item?.id}
                    onClick={() => handleFarmerSelections(item.id)}
                    className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700 "
                  >
                    <td className="hidden p-2 text-xs text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                      {index + 1}
                    </td>
                    <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                      {item?.name}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {(ZoneData?.target).toLocaleString()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {VanoStats[index]?.length?.toLocaleString()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {Math.max(
                        0,
                        (ZoneData?.target ?? 0) -
                          (VanoStats[index]?.length ?? 0),
                      ).toLocaleString()}
                    </td>
                    <td
                      className={`p-2 text-xs text-center md:text-sm ${
                        Math.min(
                          100,
                          ((VanoStats[index]?.length ?? 0) /
                            (ZoneData?.target ?? 0)) *
                            100,
                        ) < 33
                          ? "text-red-600"
                          : Math.min(
                                100,
                                ((VanoStats[index]?.length ?? 0) /
                                  (ZoneData?.target ?? 0)) *
                                  100,
                              ) < 66
                            ? "text-yellow-600"
                            : "text-green-600"
                      }`}
                    >
                      <span>
                        {isNaN(
                          ((VanoStats[index]?.length ?? 0) /
                            (ZoneData?.target ?? 0)) *
                            100,
                        )
                          ? "0.00"
                          : Math.min(
                              100,
                              ((VanoStats[index]?.length ?? 0) /
                                (ZoneData?.target ?? 0)) *
                                100,
                            ).toFixed(2)}{" "}
                        %
                      </span>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </motion.table>
          </div>
        </>
      ) : show3 ? (
        <>
          {/* widget section */}
          <div className="mb-10">
            <ProfessionalWidget
              farmersTarget={ZoneData?.target * (Vanos?.length || 1)}
              AchievedFarmers={Fam?.length}
              SalesTarget={ZoneData?.sales * (Vanos?.length || 1)}
              ArchievedSales={Pay}
            />
          </div>
          {/* Third section */}
          <div
            onClick={handleBacks}
            className="mb-5 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1 dark:text-gray-300"
          >
            <IoArrowBack className="text-2xl" />
            <h1 className="text-xs md:text-sm">Back</h1>
          </div>
          {/* Enrollment Table */}
          <div className="flex flex-row items-center mb-5 gap-x-3">
            <div>
              <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
                {ZoneData?.name} Zone Summary
              </h1>
            </div>
          </div>
          {/* Enables horizontal scrolling on small screens */}
          <div className="overflow-x-auto ">
            <motion.table
              className="w-full"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <thead className="">
                <tr className="bg-green-600 border-b md:text-sm dark:border-gray-700">
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    Particulars
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Target
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Achieved
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Remain
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    %
                  </th>
                </tr>
              </thead>
              <tbody className="">
                <motion.tr className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700 ">
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                    Enrollment
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(
                      ZoneData?.target * (Vanos?.length || 1)
                    )?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {Fam?.length}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(() => {
                      // Calculating the remaining amount
                      const targetValue =
                        ZoneData?.target * Vanos?.length - Fam?.length;

                      return (
                        targetValue !== 0 ? targetValue : ZoneData?.target
                      )?.toLocaleString();
                    })()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    <span
                      className={(() => {
                        const rawPercentage =
                          (Fam?.length /
                            ((ZoneData?.target ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return percentage < 33
                          ? "text-red-600"
                          : percentage < 66
                            ? "text-yellow-600"
                            : "text-green-600";
                      })()}
                    >
                      {(() => {
                        const rawPercentage =
                          (Fam?.length /
                            ((ZoneData?.target ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return `${percentage.toFixed(1)} %`;
                      })()}
                    </span>
                  </td>
                </motion.tr>
                <motion.tr className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700 ">
                  <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                    sales
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(ZoneData?.sales * (Vanos?.length || 1))?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {Pay?.toLocaleString()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    {(() => {
                      // Calculating the remaining amount
                      const targetValue = ZoneData?.sales * Vanos?.length - Pay;

                      return (
                        targetValue !== 0 ? targetValue : ZoneData?.sales
                      )?.toLocaleString();
                    })()}
                  </td>
                  <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                    <span
                      className={(() => {
                        const rawPercentage =
                          (Pay /
                            ((ZoneData?.sales ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return percentage < 33
                          ? "text-red-600"
                          : percentage < 66
                            ? "text-yellow-600"
                            : "text-green-600";
                      })()}
                    >
                      {(() => {
                        const rawPercentage =
                          (Pay /
                            ((ZoneData?.sales ?? 0) * (Vanos?.length ?? 0))) *
                          100;

                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        return `${percentage.toFixed(1)} %`;
                      })()}
                    </span>
                  </td>
                </motion.tr>
              </tbody>
            </motion.table>
          </div>
          {/* Vano List in certain Zone */}
          <div className="flex flex-row items-center mt-10 mb-5 gap-x-3">
            <div>
              <h1 className="text-sm font-medium text-gray-600 dark:text-gray-300 md:text-base">
                VANO list Summary
              </h1>
            </div>
          </div>
          {/* ANO List Table - Enables horizontal scrolling on small screens */}
          <div className="overflow-x-auto ">
            <motion.table
              className="w-full"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <thead className="">
                <tr className="bg-green-600 border-b md:text-sm dark:border-gray-700">
                  <th className="hidden p-2 text-xs font-bold text-left text-white md:table-cell lg:text-base md:text-sm">
                    No
                  </th>
                  <th className="p-2 text-xs font-bold text-left text-white lg:text-base md:text-sm">
                    VANO name
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Target
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Achieved
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    Remain
                  </th>
                  <th className="p-2 text-xs font-bold text-center text-white lg:text-base md:text-sm">
                    %
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {Vanos?.map((item, index) => (
                  <motion.tr
                    onClick={() => handleFarmerSelection(item.id)}
                    key={index + item?.id}
                    className="bg-white border-b dark:bg-slate-900 dark:border-gray-700 hover:bg-green-100 dark:hover:bg-gray-700"
                  >
                    <td className="hidden p-2 text-xs text-gray-900 md:table-cell dark:text-gray-300 md:text-sm">
                      {index + 1}
                    </td>
                    <td className="p-2 text-xs text-gray-900 dark:text-gray-300 md:text-sm">
                      {item?.name}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {ZoneData?.sales?.toLocaleString()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {(() => {
                        // Collect payment details

                        const VanoFarmers = farmers?.filter(
                          (dt) => dt?.creator_id === item?.id,
                        );
                        const VanoPayment = VanoFarmers?.map((user) => {
                          const VFarmers = Payment?.filter(
                            (pay) => pay?.farmer_id === user?.uuid,
                          );
                          return VFarmers;
                        });
                        const Vpayments = VanoPayment.flat();
                        const totalSumPay = Vpayments.reduce(
                          (sum, payment) => sum + payment.amount,
                          0,
                        );
                        // Return the amount calculated
                        return <span>{totalSumPay?.toLocaleString()}</span>;
                      })()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 dark:text-gray-300 md:text-sm">
                      {(() => {
                        // Calculating the remaining amount
                        const VanoFarmers = farmers?.filter(
                          (dt) => dt?.creator_id === item?.id,
                        );
                        const VanoPayment = VanoFarmers?.map((user) => {
                          const VFarmers = Payment?.filter(
                            (pay) => pay?.farmer_id === user?.uuid,
                          );
                          return VFarmers;
                        });
                        const Vpayments = VanoPayment.flat();
                        const totalSumPay = Vpayments.reduce(
                          (sum, payment) => sum + payment.amount,
                          0,
                        );
                        return (
                          ZoneData?.sales - totalSumPay || ZoneData?.sales
                        )?.toLocaleString();
                      })()}
                    </td>
                    <td className="p-2 text-xs text-center text-gray-900 md:text-sm dark:text-gray-300">
                      {(() => {
                        // Get farmers belonging to this Vano
                        const VanoFarmers = farmers?.filter(
                          (dt) => dt?.creator_id === item?.id,
                        );

                        // Get payments made by those farmers
                        const VanoPayment = VanoFarmers?.map((user) => {
                          const VFarmers = Payment?.filter(
                            (pay) => pay?.farmer_id === user?.uuid,
                          );

                          return VFarmers;
                        });

                        const Vpayments = VanoPayment?.flat() || [];

                        // Calculate total payments
                        const totalSumPay = Vpayments.reduce(
                          (sum, payment) => sum + (payment?.amount ?? 0),
                          0,
                        );

                        // Calculate percentage
                        const rawPercentage =
                          (totalSumPay / (ZoneData?.sales ?? 0)) * 100;

                        // Keep percentage between 0 and 100
                        const percentage = Number.isFinite(rawPercentage)
                          ? Math.min(100, Math.max(0, rawPercentage))
                          : 0;

                        // Determine color
                        const textColor =
                          percentage < 33
                            ? "text-red-600"
                            : percentage < 66
                              ? "text-yellow-600"
                              : "text-green-600";

                        return (
                          <span className={textColor}>
                            {percentage.toFixed(2)} %
                          </span>
                        );
                      })()}
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </motion.table>
          </div>
        </>
      ) : show4 ? (
        <>
          {/* Fourth section */}
          <div
            onClick={handleReturn}
            className="mb-5 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1 dark:text-gray-300"
          >
            <IoArrowBack className="text-2xl" />
            <h1 className="text-xs md:text-sm">Back</h1>
          </div>
          {/* Vano Summary Table */}
          <div className="mt-10 mb-10">
            <SummaryTable userdetails={userdetails} RegFarmers={RegFarmers} />
          </div>
          {/* VAno Farmers Enrollment List */}
          <div className="mt-10 mb-10">
            <FarmerTable users={RegFarmers} />
          </div>
          <div>
            <FarmerFinish users={RegFarmers} />
          </div>
        </>
      ) : show5 ? (
        <>
          {/* Fourth section */}
          <div
            onClick={handleReturns}
            className="mb-5 cursor-pointer flex flex-row items-center gap-x-3  w-[100px] py-1 dark:text-gray-300"
          >
            <IoArrowBack className="text-2xl" />
            <h1 className="text-xs md:text-sm">Back</h1>
          </div>
          {/* Vano Summary Table */}
          <div className="mt-10 mb-10">
            <SummaryTable userdetails={userdetails} RegFarmers={RegFarmers} />
          </div>
          {/* VAno Farmers Enrollment List */}
          <div className="mt-10 mb-10">
            <FarmerTable users={RegFarmers} />
          </div>
          <div>
            <FarmerFinish users={RegFarmers} />
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default AdminHome;
